import React, { useState, useEffect } from "react";
import "./RankedPromptPopup.css";

const nameList = [
  "John", "Jill", "Max", "Mark", "Park", "Showman", "Enlightened", "Dragon", "Mystic",
  "Oracle", "Phantom", "Sage", "Voyager", "Guardian", "Whisper", "Tempest", "Glimmer",
  "Crimson", "Nova", "Eclipse", "Blaze", "Astral", "Mirage", "Pioneer", "Wraith", 
  "Zenith", "Obsidian", "Spectrum", "Radiant", "Nebula", "Glyph", "Onyx", "Halcyon", 
  "Torrent", "Solstice", "Revenant", "Archer", "Bolt", "Celestial", "Dynamo", "Empyrean", 
  "Flare", "Galaxy", "Harbinger", "Inferno", "Jubilee", "Knight", "Lotus", "Monarch", 
  "Nimbus", "Omen", "Pulse", "Quest", "Rune", "Stellar", "Tide"
];

const generateRandomUsername = () => {
  const randomWord1 = nameList[Math.floor(Math.random() * nameList.length)];
  const randomWord2 = nameList[Math.floor(Math.random() * nameList.length)];
  const randomNumber = Math.floor(10 + Math.random() * 99); // 2-3 digit number
  return `${randomWord1}${randomWord2}${randomNumber}`;
};
const RankedPromptPopup = ({ isOpen, onClose, onUsernameSubmit }) => {
  const [username, setUsername] = useState(localStorage.getItem("username") || generateRandomUsername());
  const [isAnonymous, setIsAnonymous] = useState(false);
  const [dontShowAgain, setDontShowAgain] = useState(localStorage.getItem("hideRankedPopup") === "true");
  const [showNotification, setShowNotification] = useState(false);
  const [notificationText, setNotificationText] = useState("");

  useEffect(() => {
    // Set username from localStorage or generate a random one if it's empty
    const savedUsername = localStorage.getItem("username");
    if (savedUsername) {
      setUsername(savedUsername);
    } else {
      setUsername(generateRandomUsername());
      localStorage.setItem("username", username);
    }
  }, []);

  // useEffect(() => {
  //   if (localStorage.getItem("hideRankedPopup") === "true") {
  //     onClose();
  //   }
  // }, [onClose]);

  const handleConfirm = () => {
    let newUsername = username.trim();

    let currentUsername = localStorage.getItem("username");
    if (newUsername != currentUsername) {
      setNotificationText(`Username changed to ${newUsername}`);
      setShowNotification(true);

      // Hide notification after 3 seconds
      setTimeout(() => {
        setShowNotification(false);
      }, 2900);

      localStorage.setItem("username", newUsername);
    }

    // Show notification only if username is valid
    //only show if the username has been changed

    // Delay closing modal slightly so the notification appears
    onUsernameSubmit(newUsername);
    onClose();
    // setTimeout(() => {
    // }, 500);
  };

  return (
    <>
      {isOpen && (
        <div className="RankedPromptPopup-overlay">
          <div className="RankedPromptPopup-content">
            <h2>🏆</h2>
            <h1>Welcome to Ranked Mode!</h1>
            <p>
              Ranked Mode is a competitive game mode where you must match the
              correct times as quickly as possible before time runs out.
            </p>
            <br />
            <p>
              The game starts with a 60s countdown timer. Once it reaches zero,
              the round ends.
            </p>
            <br />

            {/* Scoring System Table */}
            <div className="ScoringSystem">
              <h2>Scoring System</h2>
              <table className="ScoringTable">
                <thead>
                  <tr>
                    <th>Points</th>
                    <th>Condition</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="good">+100</td>
                    <td>Exact match</td>
                  </tr>
                  <tr>
                    <td className="good">+30</td>
                    <td>Within 4 minutes</td>
                  </tr>
                  <tr>
                    <td className="good">+10</td>
                    <td>Within 5-10 minutes</td>
                  </tr>
                  <tr>
                    <td className="bad">-50</td>
                    <td>11 or more minutes off</td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* Form for Validation */}
            <form onSubmit={handleConfirm}>
              <div className="RankedPromptPopup-input-section">
                <label htmlFor="username">
                  Enter your username for high scores:
                </label>
                <div className="username-input-container">
                  <input
                    type="text"
                    id="username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    placeholder="Enter username"
                    pattern="[A-Za-z0-9!@#$%&*]{3,20}"
                    title="3-12 chars, A-Z, 0-9, and !@#$%&* only."
                    required
                  />
                  <button
                    type="button"
                    className="random-username-btn"
                    onClick={() => setUsername(generateRandomUsername())}
                  >
                    Generate Username
                  </button>
                </div>
              </div>

              {/* Confirmation Button (Must be inside form for validation to work) */}
              <button type="submit" className="RankedPromptPopup-confirm">
                I'm Ready!
              </button>
            </form>

            {/* Close Button */}
            <button className="RankedPromptPopup-close" onClick={onClose}>
              ✖
            </button>

            {/* Checkbox for "Don't Show Again" */}
            <label className="checkbox-container">
              <input
                type="checkbox"
                checked={dontShowAgain}
                onChange={() => {
                  localStorage.setItem("hideRankedPopup", !dontShowAgain);
                  setDontShowAgain(!dontShowAgain);
                }}
              />
              <div className="doNotShowMsg">Don't show this message again</div>
            </label>

            <p className="RankedPromptPopup-footer">
              You can change your username at any time.
            </p>
          </div>
        </div>
      )}

      {showNotification && (
        <div className="notification-bubble">{notificationText}</div>
      )}
    </>
  );
};

export default RankedPromptPopup;